import Vue from 'vue'
import App from './App.vue'
import {auth} from './firebase'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import './fontawesome'
import titleComponent from '@/components/Title.vue';

Vue.use(Buefy, {
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fas',
});

Vue.config.productionTip = false

Vue.component('vue-title', titleComponent);

String.prototype.capitalise = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

let app
auth.onAuthStateChanged(user => {

  if (user) {
    store.dispatch('fetchUser', user)
  }
  
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

  
})
